import { imgPrefix } from '@/utils/imgPrefix';
import { Button } from 'darrius';
import Image from 'next/image';
import styles from '../FeedbackValidation.module.scss';
import Link from 'next/link';

export default function FeedbackValidationTimeoutLiveness() {
  return (
    <div className={`${styles['wrapper-feedback']}`}>
      <p className={`${styles['main-title']}`}>Reconhecimento facial</p>

      <div className={`${styles['feedback']}`}>
        <Image
          src={imgPrefix('/images/idwall/document-validation-error.svg')}
          alt="Validação de documentos em andamento"
          width={164}
          height={192}
          quality={100}
        />

        <p className={`${styles['feedback-title']}`}>
          Estamos demorando mais do que o normal para verificar a imagem
        </p>

        <span>
          Te daremos um retorno em até 72h. Enquanto isso, você pode navegar
          pelo aplicativo.
        </span>

        <Link href={'https://www.getninjas.com.br/instale'}>
          <Button.Root
            type="button"
            variation="primary"
            className={`${styles['feedback-button']}`}
          >
            Fazer download do aplicativo
          </Button.Root>
        </Link>
      </div>
    </div>
  );
}
